import styled from '@emotion/styled';

interface TableListSizeCounterFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
}

const TableListSizeCounterFormatter: React.FC<
  TableListSizeCounterFormatterProps
> = ({ data, dataKey }) => {
  const label = data && data[dataKey ?? ''];
  const listSize = Array.isArray(label) ? label.length : 0;
  return <Container>{listSize}</Container>;
};

export default TableListSizeCounterFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;
